import { styled } from "styled-system/jsx";

export const SelectableMediumSquareButton = styled("button", {
  base: {
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "flex-start",
    alignSelf: "stretch",
    gap: "100",
    borderRadius: "100",
    border: "1px solid",
    borderColor: "border.light",
    bg: "ink.100",
    boxShadow: "inset 0 0 0 0 transparent",
    p: "200",
    cursor: "pointer",
    color: "text.dark",
    transitionDuration: "normal",
    transitionProperty: "border-color, color, box-shadow, background",
    transitionTimingFunction: "default",
    _hover: {
      borderColor: "border.mid",
      boxShadow: "inset 0 0 0 1px var(--wa-colors-border-mid)",
      bg: "white",
    },
    _disabled: {
      opacity: 0.6,
      cursor: "not-allowed",
      _hover: {
        borderColor: "border.light",
        boxShadow: "inset 0 0 0 0 transparent",
        bg: "ink.100",
      },
    },
    '&[aria-selected="true"]': {
      bg: "white",
      borderColor: "border.dark",
      boxShadow: "inset 0 0 0 1px var(--wa-colors-border-dark)",
      color: "text.dark",
      _hover: {
        borderColor: "border.dark",
        boxShadow: "inset 0 0 0 1px var(--wa-colors-border-dark)",
      },
    },
    "& svg": {
      flexShrink: 0,
    },
  },
});
